import { useI18n } from '@/i18n'
import { cn } from '@/lib/cn'

/** Two-state ID / EN switch. Labelled for screen readers, compact on mobile. */
export function LanguageToggle({ className }: { className?: string }) {
  const { locale, setLocale, t } = useI18n()

  return (
    <div
      role="group"
      aria-label={t.common.switchLanguage}
      className={cn(
        'inline-flex items-center rounded-full border border-gold/25 p-0.5 text-[0.6875rem] font-medium uppercase tracking-[0.14em]',
        className,
      )}
    >
      {(['id', 'en'] as const).map((code) => (
        <button
          key={code}
          type="button"
          onClick={() => setLocale(code)}
          aria-pressed={locale === code}
          className={cn(
            'min-h-8 rounded-full px-3 transition-colors duration-200',
            locale === code ? 'bg-gold text-ink' : 'text-muted hover:text-gold',
          )}
        >
          {code}
        </button>
      ))}
    </div>
  )
}
